"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A link is only keyboard accessible by default when it has an `href` attribute.
 * The `handleKeyDown` and `tabIndex` logic was added to support keyboard users since some products currently use the `onClick` prop.
 * Once products are updated, this logic can be removed if the `onClick` prop is no longer necessary.
 */
var SidebarLink = function SidebarLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isRouterLink = _ref.isRouterLink,
      onClick = _ref.onClick,
      to = _ref.to,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "isRouterLink", "onClick", "to"]);

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      onClick();
    }

    return;
  };

  var linkProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    className: className,
    onClick: onClick,
    onKeyDown: !to ? handleKeyDown : null,
    tabIndex: !to ? '0' : null
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isRouterLink ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({
    to: to
  }, linkProps), children) : /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: to
  }, linkProps), children));
};

SidebarLink.propTypes = {
  /** The content that goes inside the <Link> or <a>  */
  children: _propTypes.default.node.isRequired,

  /** Allows us to use styled-components `styled` method */
  className: _propTypes.default.string,

  /** Renders a React Router Link so page will not refresh */
  isRouterLink: _propTypes.default.bool,

  /** Some products currently use this to direct navigation. */
  onClick: _propTypes.default.func,

  /** The URL assigned to the `to` attribute on a React Router Link or to the `href` on a regular link.
   * When using the default HTML anchor element, to should be passed a string.
   * When using isRouterLink, to can be a string, an object, or a function that returns a string or object.
   */
  to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
};
SidebarLink.defaultProps = {
  className: null,
  isRouterLink: false,
  onClick: null,
  to: null
};
var _default = SidebarLink;
exports.default = _default;